export const NEW_TRACK = '[Tracks] New track';

export const DISABLE_REPLICATE_COLLABORATORS =
  '[Tracks] Disable replicate collaborator';

export const CREATE_TRACK = '[Tracks] Create track';
export const CREATE_TRACK_SUCCESS = '[Tracks] Create track Success';
export const CREATE_TRACK_ERROR = '[Tracks] Create track Error';

export const UPDATE_TRACK_FIELD = '[Tracks] Update track field';
export const UPDATE_INVALID_FORM = '[Tracks] Update invalid form';

export const GET_TRACKS = '[Tracks] Get tracks';
export const LIST_MULTIPLE_TRACKS = '[Tracks] List tracks';
export const GET_TRACKS_SUCCESS = '[Tracks] Get tracks Success';
export const GET_TRACKS_ERROR = '[Tracks] Get tracks Error';

export const UPDATE_TRACK = '[Tracks] Update track';
export const UPDATE_TRACK_SUCCESS = '[Tracks] Update track Success';
export const UPDATE_TRACK_ERROR = '[Tracks] Update track Error';

export const UPDATE_TRACK_ORDER = '[Tracks] Update track order';
export const UPDATE_TRACK_ORDER_SUCCESS = '[Tracks] Update track order Success';
export const UPDATE_TRACK_ORDER_ERROR = '[Tracks] Update track order Error';

export const REMOVE_TRACK = '[Tracks] Remove track';
export const REMOVE_TRACK_SUCCESS = '[Tracks] Remove track Success';
export const REMOVE_TRACK_ERROR = '[Tracks] Remove track Error';

export const RESET_TRACKS_STORE = '[Tracks] Reset tracks store';
